<mat-form-field floatLabel="always" (click)="openOptionDialog()" class="fd-option-picker__container" color="accent" [formGroup]="parentForm">
  <mat-label>{{field?.label}}</mat-label>
  <mat-select placeholder="{{getText()}}" (openedChange)="cancelEvent($event)"[id]="field?.controlName" [formControl]="relatedFormControl" [required]="field?.required">
  </mat-select>
  <mat-error *ngIf="hasError"><div *ngFor="let errorMessage of errorMessages">{{errorMessage}}</div></mat-error>
</mat-form-field>